import React from 'react'
import styled, { css } from 'styled-components'

const TagStyled = styled.div`
  height: 32px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: ${(props) => (props.selected ? '2px solid var(--cobasi-blue-light-8)' : '1px solid var(--gray-7)')};
  border-radius: 68px;
  padding: 0 12px;
  cursor: pointer;

  background-color: ${(props) => (props.selected ? 'var(--pet-anjo-lighter-blue)' : 'white')};

  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 18px;

  color: ${(props) => (props.selected ? 'var(--cobasi-blue-light-8)' : 'var(--gray-5)')};

  ${({ disabled }) => disabled && css`
    color: var(--silver);
    border-color: var(--silver);
    pointer-events: none;
  `}

  svg {
    path {
      fill: ${(props) => props.selected ? 'var(--cobasi-blue-light-8)' : 'var(--gray-7)'};
    }
  }
`
const Tag = ({ disabled, selected, onClick, children }) => {
  return (
    <TagStyled
      onClick={onClick}
      disabled={disabled}
      selected={selected}
    >
      {children}
    </TagStyled>
  )
}

export default Tag
